exports = module.exports = require("../../../../node_modules/fast-css-loader/lib/css-base.js")(false);
// imports

// module
exports.push([module.id, ".toggle-control-bar {\n  display: grid;\n  grid-template-columns: 1fr auto; }\n", ""])